import moment from "moment";
import { isArray } from "underscore";
import { convertFormatFromApiToMoment } from "./conversions";

export const getDate = (dateToUse?: Date | Date[] | undefined) => {
  let currentDate = new Date();
  if (dateToUse) {
    if (isArray(dateToUse))
      currentDate = dateToUse[0];
    else
      currentDate = dateToUse;
  }
  return currentDate;
}

export const convertDateToStringFormat = (value: string, dateFormat: string, dateToUse?: Date | Date[] | undefined) => {
  const dateToFormat = new Date(value);
  const convertedDateFormat = convertFormatFromApiToMoment(dateFormat);
  const tenYearsAgo = moment().subtract(2, 'years').format(convertedDateFormat);
  let currentDate = moment(dateToFormat).format(convertedDateFormat);
  if (tenYearsAgo > currentDate) {
    if (dateToUse) {
      if (isArray(dateToUse))
        currentDate = moment(dateToUse[0]).format(convertedDateFormat)
      else
        currentDate = dateToUse ? moment(dateToUse).format(convertedDateFormat) : moment().format(convertedDateFormat)
    }
    else
      currentDate = moment().format(convertedDateFormat);
  }

  return currentDate;
}

export const convertDateToApiFormat = (value: Date | Date[] | undefined) => {
  if (isArray(value))
    return moment(value[0]).format("YYYY-MM-DD")
  else
    return value ? moment(value).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD")
}

export const convertDateOfDateToStringFormat = (value: Date | Date[] | undefined, dateFormat: string) => {

  const convertedDateFormat = convertFormatFromApiToMoment(dateFormat);
  let dt = new Date();
  if (value) {
    if (isArray(value))
      dt = value[0];
    else
      dt = value;
  }

  return moment(dt).format(convertedDateFormat);
}



export const randomNo = () => Math.floor(Math.random() * 35) + 1;

export const setValToZeroIfNegative = (param: string | null | undefined): number => {
  const cleaned = typeof param === "string" ? param.trim() : "";
  const val = Number(cleaned);
  if (isNaN(val) || val < 0) {
    return 0;
  }
  return val;
};


export const tenantIsAhab = (tenantName: string | null) => {
  return (tenantName === "ahab" || tenantName === "ahabshipping" || tenantName === "catapultnw" || tenantName === "ahab-historical");
}

export const tenantIsKaffebakeriet = (tenantName: string | null) => {
  return tenantName === "kaffebakeriet";
}

export const tenantIsChalkhills= (tenantName: string | null) => {
  return (tenantName === "chalkhills");
}


export const getAddToCartButtonName = (foundInCart: boolean, isSample: boolean) => {
  if (foundInCart) {
    if (isSample)
      return "UpdateCart";
    else
      return "UpdateCart";
  }
  else {
    return "NewCart_AddToCart";
  }
}

/**
 * 
 * @param token JWT token bearer from login
 * @returns parsed token
 */
export const parseJwtToken = (token: string) => {
  try {
    return JSON.parse(window.atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
}

/**
 * 
 * @returns current time in seconds
 */
export const getCurrentTimeSeconds = (): number => {
  return Math.floor(Date.now() / 1000);
}

/**
 * 
 * @param token JWT token bearer from login
 * @param setAction setState action to be executed
 * @returns 
 */
export const getTokenExpiryTimer = (token: string, setAction: React.Dispatch<React.SetStateAction<boolean>>): ReturnType<typeof setTimeout> => {

  return (setTimeout(() => {
    // console.log("%c setTimeout fire!!--- ", 'background-color: orange; color: black;')
    // console.log("%c getTokenExpiryTimer SET ", 'background-color: blue; color: black;')
    if (isTokenExpired(token)) {
      // console.log("%c getTokenExpiryTimer FIRE!!:: ", 'background-color: blue; color: black;')

      setAction(true)
    }
  }, (getTokenExpiryTimeLeftSeconds(token) * 1000)));
}

/**
 * 
 * @param token JWT token bearer from login
 * @returns seconds for timer
 */
export const getTokenExpiryTimeLeftSeconds = (token: string): number => {

  let leftSeconds = 0;

  try {
    const decodedToken = parseJwtToken(token);
    const expirySeconds: number = decodedToken?.exp;
    const currentSeconds: number = getCurrentTimeSeconds();
    leftSeconds = expirySeconds - currentSeconds

    // console.log("%c getTokenExpiryTimeLeftSeconds token true:: ", 'background-color: blue; color: black;', decodedToken, expirySeconds, currentSeconds, leftSeconds, (leftSeconds * 1000))


  } catch (error) {
    console.error(error);
  }

  return leftSeconds;
}

/**
 * 
 * @param token JWT token bearer from login
 * @returns bool if token is invalid/expired
 */
export const isTokenExpired = (token: string): boolean => {
  let isExpired = false;
  try {
    const decodedToken = parseJwtToken(token);
    const expiryTime: number = decodedToken?.exp * 1000;
    const currentTime: number = Date.now();
    isExpired = expiryTime < currentTime
  } catch (error) {
    console.error(error);
  }

  return isExpired;
}

export const dateToUTC = (value: Date) => {
  const dateObj = new Date(value);
  return new Date(dateObj.getTime() + dateObj.getTimezoneOffset() * 60000);
}


export const areArraysEqual = (arr1:any, arr2:any) => {

  return arr1.every((item1:any, index:any) => {
    const item2 = arr2[index];

    // Compare keys and values of both objects
    return (
      Object.keys(item1).length === Object.keys(item2).length &&
      Object.keys(item1).every(key => item1[key] === item2[key])
    );
  });
};
